<template>
    <div class="relative" v-bind:class="spanclass">

      <div class="border-bg-rollover center-flex" v-bind:class="ratioclass">
        <slot></slot>
      </div>

      <!-- <crosshair-background></crosshair-background> -->

    </div>
</template>

<script>
  import crosshair_background from '../atoms/crosshair_background'
  export default {
    props: ['spanclass', 'ratioclass'],
    components: {
      'crosshair-background': crosshair_background
    }
  }
</script>



// WEBPACK FOOTER //
// rollover_card.vue?eabfb8d8